import React, { useState } from 'react'
import { Viewer, Worker } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
import {
  Modal, ModalBody, ModalFooter,
  ModalHeader, ModalTitle, Button
} from 'react-bootstrap'

// Import required CSS
import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'

export default function FilePreview({ file }) {
  const [show, setShow] = useState(false)

  const fileExtension = file.name ? file.name.split('.').pop().toLowerCase() : ''

  // Create plugin instance for PDF viewer
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: (defaultTabs) => [],
    toolbarPlugin: {
      fullScreenPlugin: {
        enableShortcuts: false,
      },
      getFilePlugin: {
        fileNameGenerator: () => file.name,
      },
      printPlugin: {
        enableShortcuts: false,
      },
    },
  })

  const renderFileContent = () => {
    if (file.is_image) {
      return (
        <img
          src={file.url}
          alt={file.name}
          style={{
            maxWidth: '100%',
            maxHeight: '70vh',
            objectFit: 'contain'
          }}
        />
      )
    }

    switch (fileExtension) {
      case 'pdf':
        return (
          <Worker workerUrl="/pdf.worker.min.js">
            <div style={{ height: '70vh', border: '1px solid rgba(0, 0, 0, 0.3)' }}>
              <Viewer
                fileUrl={file.url}
                plugins={[defaultLayoutPluginInstance]}
              />
            </div>
          </Worker>
        )

      case 'txt':
      case 'html':
      case 'htm':
        return (
          <iframe
            src={file.url}
            style={{
              width: '100%',
              height: '70vh',
              border: '1px solid rgba(0, 0, 0, 0.3)'
            }}
            title={file.name}
            sandbox="allow-same-origin"
          />
        )

      default:
        return (
          <div className="text-center p-4">
            <i className="fas fa-file fa-3x mb-3 text-muted"></i>
            <p className="text-muted">
              Preview not available for this file type.
              <br />
              <small>Download the file to view its contents.</small>
            </p>
            <a
              href={file.url}
              download={file.name}
              className="btn btn-primary btn-sm"
            >
              <i className="fas fa-download me-2"></i>
              Download {file.name}
            </a>
          </div>
        )
    }
  }

  return (
    <>
      <Button
        variant="none"
        style={{ padding: "0px" }}
        onClick={() => setShow(true)}
      >
        {file.is_image ?
          <img src={file.url} alt="" style={{ width: '200px' }}></img>
          :
          <div className='border border-info border-2 rounded p-1'>{file.name}</div>
        }
      </Button>
      <Modal
        size="lg"
        show={show}
        onHide={() => setShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            {file.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {renderFileContent()}
        </Modal.Body>
      </Modal>
    </>
  )
}